<template>
  <div class="home">
    <!-- <Banner></Banner> -->
    <ShowTemplates :templateList="temp"></ShowTemplates>
  </div>
</template>

<script>
import ShowTemplates from "@/components/showTemplates.vue";
import { getIndex ,getIndexInfo} from "@/api/index";
export default {
  name: "Home",
     metaInfo() {
      return { 
        title: this.pageInfo.mTitle, // set a title
      meta: [{                 // set meta
        name: 'keyWords',
        content: this.pageInfo.mSeoKey
      }],
      link: [{                 // set link
        rel: 'description',
        href: this.pageInfo.mSeoDescription
      }]
      }
    },
  components: {
ShowTemplates
  }, created(){
    getIndexInfo().then(response => {
this.pageInfo=response.data 
})
 getIndex().then(response => {
this.temp=response.data 
})
  },
  data() {
    return {
      temp: [],
      pageInfo:{
        mTitle:'华南软件官网',
        mSeoKey:'华南软件官网',
        mSeoDescription:'华南软件官网',
      }
  }
}
}

</script>




